import React, {useRef, useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import StringUtil from "utils/StringUtil";
import CommonUtil from "utils/CommonUtil";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import UI from "../../../../components/UI";
import PageLoading from "../../../../components/loading";
import DateUtil from "../../../../utils/DateUtil";
import UIUtils from "../../../../utils/UIUtils";
import paramStore from "common/page/store/ParamStore";
function ContentsContainer() {
	const location = useLocation();
	const searchData = (location.state as any)?.data;
  	const receivedData = paramStore.getParam("adm1206");
	const history = useHistory();
	const serverUrl = 'http://dev.fund.win-win.or.kr/';

	const [loadFinish,setLoadFinish] = useState(false);

	//파일정보 선언
	const [reqFileNm, setReqFileNm] = useState('');

	const [corpLogoFileValue] = useState(new TbComFile());
	const [bizLicFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());
	const [reqFileValue] = useState(new TbComFile());

	let remainCount = useRef<string>("");

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);
	const [elec, setElec] = useState('');
	const [receNo, setReceNo] = useState('');

	const [bizCd ,setBizCd] = useState('');
	const [donNo ,setDonNo] = useState('');
	const [REC1, setREC1] = useState<any>({});
	const [REC2, setREC2] = useState<any>({});
	const [REC3, setREC3] = useState<any>({});
	const [REC4, setREC4] = useState<any>({});
	const [REC5, setREC5] = useState<any>({});
	const [REC6, setREC6] = useState<any>({});
	const [REC7, setREC7] = useState<any>({});
	const [REC8, setREC8] = useState<any>({});
	const [reduReceNo, setReduReceNo] = useState('');
	
	React.useEffect(() => {

		//넘어온 파라미터 바인딩
		if(receivedData !==undefined){
			setBizCd(StringUtil.defaultString(receivedData.vBIZ_CD));
			setDonNo(StringUtil.defaultString(receivedData.vDON_NO));
			initCall();
			setLoadFinish(true);

		}else{
			history.push({
				pathname: './adm1205',  
			});
		}
		return () => {
			if(receivedData !== undefined){

			}
		}
	},[]);

	async function initCall(){
		//console.log("bizNo " +receivedData.vBIZ_NO);
		//let bizNo = receivedData.vBIZ_NO;

		let param1 = {
			"DON_NO" : receivedData.vDON_NO
		};


		//파라미터 전송
		const response1:any = await CommonUtil.execute({
			url:'adm_3200',
			data: param1
		})

		const result1 = response1;
		if(result1.REC.length != 0) setReceNo(result1.REC[0].RECE_NO);
		
		
		if(result1.REC[0].RECE_NO.indexOf(',') != -1){
			let splitList = result1.REC[0].RECE_NO.split(','); 
			setReduReceNo(splitList[0]+" 외 "+(splitList.length-1)+"건");
		}else{
			// @ts-ignore
			setReduReceNo(result1.REC[0].RECE_NO);
		}
		
		let param = {
			"DON_NO": receivedData.vDON_NO,
			"BIZ_CD": receivedData.vBIZ_CD
		};

		const response:any = await CommonUtil.execute({
			url:'adm_1206',
			data: param
		})

		const result = response;
		//setCorpInfo(result);
		setREC1(result.REC1);
		setREC2(result.REC2);
		setREC3(result.REC3);
		setREC4(result.REC4);
		setREC5(result.REC5);
		setREC6(result.REC6);
		setREC7(result.REC7);
		setREC8(result.REC8);

		console.log(result)


        // REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
		fileValue.setTbComFileMapngDetailList([]);
		reqFileValue.setTbComFileMapngDetailList([]);
		let fileList = result.FILE_INFO;
		for(let i = 0; i < fileList.length; i++){

			if(fileList[i].FILE_GB == 'REQ'){
				let reqFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(reqFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(reqFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(reqFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(reqFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(reqFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(reqFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(reqFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(reqFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(reqFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(reqFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(reqFileInfo.REGIST_DT);
				reqFileValue.putTbComFileMapngDetailList(fileDetail);
				//setReqFileNm(reqFileInfo.ORGINL_FILE_NM);

			}else{
				let fileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(fileInfo.DWLD_ID);
				fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
				fileDetail.setStrePath(fileInfo.STRE_PATH);
				fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
				fileDetail.setFileSize(fileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(fileInfo.REGIST_DT);
				fileValue.putTbComFileMapngDetailList(fileDetail);
			}


		}

		if(result.REC1.ELEC_APPR_YN == 'Y'){
			setElec("전자인증")
		}else if(reqFileValue.tbComFileMapngDetailList.length != 0){
			setElec("서면")
		}else{
			setElec("미제출")
		}

		setLoadFinish(true);
		
		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('result is not loaded!!!')
			return;
		}
	};


	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dueDateConverter(dueDate, type){

		if(dueDate == null) return '';

		if(type == 'date'){
			dueDate = dateToStr(dueDate);
			return dueDate.substring(0, 10);
		}else if(type == 'diff'){
			if(/^(-?)[0-9]+$/.test(dueDate)){
				dueDate = Number(dueDate);
			}

			const due = new Date(dueDate);
			const now = new Date();
			const timeGap = due.getTime() - now.getTime();

			// 남은 일수 카운트
			const remainDay = Math.ceil(timeGap / (1000 * 60 * 60 * 24));
			remainCount.current = remainDay+'';
			return '('+remainDay+'일)';
		}else if(type == 'all'){
			dueDate = dateToStr(dueDate);
			const due = new Date(dueDate);
			const now = new Date();
			const timeGap = due.getTime() - now.getTime();

			// 남은 일수 카운트
			const remainDay = Math.ceil(timeGap / (1000 * 60 * 60 * 24));
			remainCount.current = remainDay+'';
			return dueDate.substring(0, 10) + ' ('+remainDay+'일)';
		}

		return '';
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}


	function changeConvert(text, type){
		if(text == undefined) return type == 'AMT' ? '0' : '';

		if(type == 'BIZ_NO'){
			text = text.substring(0, 3) + '-' + text.substring(3, 5) + '-' + text.substring(5);
		}else if(type == 'AMT'){
			text = StringUtil.formatNumber(Number(text));
		}else if(type == 'OFC_TEL_NO'){
			text = text.replace(/[^0-9]/g, '').replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,"$1-$2-$3");
		}

		return text;

	}

	function getOzReport(){
		//체크박스 체크된 row만 가져오기
		let maxRow = 50;

		let receNoList = [];

		if(receNo.indexOf(',') != -1){
			let splitList = receNo.split(',');
			for(let j = 0; j < splitList.length; j++){
				// @ts-ignore
				receNoList.push(splitList[j]);
			}
		}else{
			// @ts-ignore
			receNoList.push(receNo);
		}

		if(receNoList.length > maxRow){
			UIUtils.alert('영수증번호 기준 최대 '+maxRow+'개를 초과할수없습니다. 시스템 관리자에게 문의 하세요').then();
			return false;
		}else{
			let dummy = maxRow - receNoList.length;
			for(let i = 0; i < dummy; i++){
				// @ts-ignore
				receNoList.push('');
			}
		}

		UIUtils.openOZReportViewerPopup({
			title: "기부금영수증",
			reportName: "rece_receipt",
			parameter: {
				"odi.odinames": "rece_receipt",
				"odi.rece_receipt.pcount": "50",
				"odi.rece_receipt.args1": "rece_no1=" + receNoList[0],
				"odi.rece_receipt.args2": "rece_no2=" + receNoList[1],
				"odi.rece_receipt.args3": "rece_no3=" + receNoList[2],
				"odi.rece_receipt.args4": "rece_no4=" + receNoList[3],
				"odi.rece_receipt.args5": "rece_no5=" + receNoList[4],
				"odi.rece_receipt.args6": "rece_no6=" + receNoList[5],
				"odi.rece_receipt.args7": "rece_no7=" + receNoList[6],
				"odi.rece_receipt.args8": "rece_no8=" + receNoList[7],
				"odi.rece_receipt.args9": "rece_no9=" + receNoList[8],
				"odi.rece_receipt.args10": "rece_no10=" + receNoList[9],
				"odi.rece_receipt.args11": "rece_no11=" + receNoList[10],
				"odi.rece_receipt.args12": "rece_no12=" + receNoList[11],
				"odi.rece_receipt.args13": "rece_no13=" + receNoList[12],
				"odi.rece_receipt.args14": "rece_no14=" + receNoList[13],
				"odi.rece_receipt.args15": "rece_no15=" + receNoList[14],
				"odi.rece_receipt.args16": "rece_no16=" + receNoList[15],
				"odi.rece_receipt.args17": "rece_no17=" + receNoList[16],
				"odi.rece_receipt.args18": "rece_no18=" + receNoList[17],
				"odi.rece_receipt.args19": "rece_no19=" + receNoList[18],
				"odi.rece_receipt.args20": "rece_no20=" + receNoList[19],
				"odi.rece_receipt.args21": "rece_no21=" + receNoList[20],
				"odi.rece_receipt.args22": "rece_no22=" + receNoList[21],
				"odi.rece_receipt.args23": "rece_no23=" + receNoList[22],
				"odi.rece_receipt.args24": "rece_no24=" + receNoList[23],
				"odi.rece_receipt.args25": "rece_no25=" + receNoList[24],
				"odi.rece_receipt.args26": "rece_no26=" + receNoList[25],
				"odi.rece_receipt.args27": "rece_no27=" + receNoList[26],
				"odi.rece_receipt.args28": "rece_no28=" + receNoList[27],
				"odi.rece_receipt.args29": "rece_no29=" + receNoList[28],
				"odi.rece_receipt.args30": "rece_no30=" + receNoList[29],
				"odi.rece_receipt.args31": "rece_no31=" + receNoList[30],
				"odi.rece_receipt.args32": "rece_no32=" + receNoList[31],
				"odi.rece_receipt.args33": "rece_no33=" + receNoList[32],
				"odi.rece_receipt.args34": "rece_no34=" + receNoList[33],
				"odi.rece_receipt.args35": "rece_no35=" + receNoList[34],
				"odi.rece_receipt.args36": "rece_no36=" + receNoList[35],
				"odi.rece_receipt.args37": "rece_no37=" + receNoList[36],
				"odi.rece_receipt.args38": "rece_no38=" + receNoList[37],
				"odi.rece_receipt.args39": "rece_no39=" + receNoList[38],
				"odi.rece_receipt.args40": "rece_no40=" + receNoList[39],
				"odi.rece_receipt.args41": "rece_no41=" + receNoList[40],
				"odi.rece_receipt.args42": "rece_no42=" + receNoList[41],
				"odi.rece_receipt.args43": "rece_no43=" + receNoList[42],
				"odi.rece_receipt.args44": "rece_no44=" + receNoList[43],
				"odi.rece_receipt.args45": "rece_no45=" + receNoList[44],
				"odi.rece_receipt.args46": "rece_no46=" + receNoList[45],
				"odi.rece_receipt.args47": "rece_no47=" + receNoList[46],
				"odi.rece_receipt.args48": "rece_no48=" + receNoList[47],
				"odi.rece_receipt.args49": "rece_no49=" + receNoList[48],
				"odi.rece_receipt.args50": "rece_no50=" + receNoList[49],
				"information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
				// "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
				// "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

				"pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
				"pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

				"export.format":"pdf", // 저장포맷
				"export.filename": "기부금영수증" + ".pdf", // 파일명
				"export.mode":"silent", // 설정창 보여줄지 여부

				"viewer.pagedisplay":"continuous", // 페이지 표시 옵션
				"viewer.viewmode":"normal", // 보고서 보기 모드
				"viewer.zoom": "90"
			},
			onClose: () => {
				console.log("Report Viewer Close");
			}
		})
	}
	
	function getOzReportReq(){
		
		UIUtils.openOZReportViewerPopup({
			title: "출연신청서",
			reportName: "don_req",
			parameter: {
				"odi.odinames": "don_req",
				"odi.don_req.pcount": "1",
				"odi.don_req.args1": "don_no=" + donNo,
				"information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
				// "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
				// "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

				"pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
				"pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

				"export.format":"pdf", // 저장포맷
				"export.filename": "출연신청서" + ".pdf", // 파일명
				"export.mode":"silent", // 설정창 보여줄지 여부

				"viewer.pagedisplay":"continuous", // 페이지 표시 옵션
				"viewer.viewmode":"normal", // 보고서 보기 모드
				"viewer.zoom": "90"
			},
			onClose: () => {
				console.log("Report Viewer Close");
			}
		})
	}



	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">기금관리</Link></li>
					<li><Link to="#">출연현황</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">출연 상세 </h1>
					<h3 className="section-title mb15">사업 출연 정보</h3>

					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">출연번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC1.DON_NO_FMT} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연상태</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC1.DON_PROC_STS_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연사업</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC1.BIZ_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연 신청일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={dateToStr(REC1.DON_REQ_DATE)} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연 일자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={dateToStr(REC1.DON_DATE)} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">기부금영수증번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={reduReceNo} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">전자인증 여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={elec} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">기부내용</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC1.DON_CONT_DIV_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연 계좌번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ '하나은행 ' + REC1.ACCT_NO_DES} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">3년 만기도래일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={dueDateConverter(REC1.DUE_DATE, 'all')} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연신청금액(원)</p>
								<div className="fo-value">
									<div className="hz-root hz-right hz-gap8 w100p">
										<UIInput className={'tf ta-right w100p'} value={changeConvert(REC1.DON_REQ_AMT, 'AMT') } placeholder={''} readOnly={true} />
										<span className="hz-item tx fc-pri">{StringUtil.isNotEmpty(Number(REC1.DON_REQ_AMT) + "")
											? '('+StringUtil.numKorPattern(Number(REC1.DON_REQ_AMT)) + " 원)"
											: ""}</span>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연금액(원)</p>
								<div className="fo-value">
									<div className="hz-root hz-right hz-gap8 w100p">
										<UIInput className={'tf ta-right w100p'} value={changeConvert(REC1.DON_AMT, 'AMT') } placeholder={''} readOnly={true} />
										<span className="hz-item tx fc-pri">{StringUtil.isNotEmpty(Number(REC1.DON_AMT) + "")
											? '('+StringUtil.numKorPattern(Number(REC1.DON_AMT)) + " 원)"
											: ""}</span>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">기금사용용도</p> {/*2024.10.16 추가*/}
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={REC1.FUN_PUR_USE_NM} placeholder={''} readOnly={true} />
									</div>
							</div>

						</div>
					</form>

					<h3 className="section-title mb15">첨부파일</h3>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							{ REC1.ELEC_APPR_YN == 'N' && reqFileValue.tbComFileMapngDetailList.length == 0 &&
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">출연신청서</p>
								<div className="fo-value">
									<p className="tx tx-cp1">출연신청서 제출이 완료되지 않았습니다.</p>
								</div>
							</div>
							}
							{ REC1.ELEC_APPR_YN =='Y' &&
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">출연신청서</p>
									<div className="fo-value">
										<div className="hz-root hz-sb hz-gap8 w100p">
											<p className="hz-item tx tx-cp1">출연신청서 전자인증을 완료하였습니다.</p>
											<Button color="gray-o" size="md" onClick={() => getOzReportReq()}>미리보기</Button>
										</div>
									</div>
								</div>
							}
							{ REC1.ELEC_APPR_YN =='N' && reqFileValue.tbComFileMapngDetailList.length == 1 &&
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">출연신청서</p>
									<div className="fo-value">
										<div className="hz-root hz-sb hz-gap8 w100p">
											<UI.FileDownloadSimpleMode value={reqFileValue} viewMode={"fund-download"}/>
										</div>
									</div>
								</div>
							}
						</div>
					</form>
					<div className="mb30">
						<div className='w100p'>
							<UI.FileDownload
								value={fileValue}
								className={'w100p'}
							/>
						</div>
					</div>

					<h3 className="section-title mb15">출연 기업 정보</h3>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC3.CORP_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">법인사업자번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC3.CORP_REG_NO} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사업자번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={changeConvert(REC3.BIZ_NO, 'BIZ_NO')} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연신청자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC3.PERSON_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">직급</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC3.POSI_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">부서</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC3.DEPT_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">이메일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={REC3.EMAIL_ADRES} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">전화번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={changeConvert(REC3.OFC_TEL_NO, 'OFC_TEL_NO')} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5">
						{ REC1.DON_PROC_STS_CD == 'G' && <Button color="pri-o" size="sm" onClick={() => getOzReport()}>기부금영수증 출력</Button> }
						<Button color="gray-o" size="sm" onClick={() => window.history.back()}>목록</Button>
					</div>

				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;